import { ErrorScreen } from '@/Ship/Components/AccessDenied'

import type { ComponentType } from 'react'

/**
 * Чи ввімкнено модуль «Диск» на цьому стенді (54631). Поки диск не показують
 * клієнтам, він вимкнений за замовчуванням: без `VITE_DISK_ENABLED=true` немає
 * пункту меню, а сторінки диска за прямим посиланням показують 404. Бек закрито
 * окремо — `DISK_ENABLED` (`DiskFeatureGateListener`).
 */
export const DISK_ENABLED = import.meta.env['VITE_DISK_ENABLED'] === 'true'

/** Сторінка диска або 404, якщо модуль вимкнено. */
export const withDiskFeature = <P extends object>(Page: ComponentType<P>): ComponentType<P> => {
    const Gated = (props: P) =>
        DISK_ENABLED ? <Page {...props} /> : <ErrorScreen image="/assets/errors/error404.svg" title="Сторінку не знайдено" />

    Gated.displayName = `withDiskFeature(${Page.displayName ?? Page.name ?? 'Page'})`

    return Gated
}
